module.exports = "/images/magnet-1963.jpg?7dd938d0021e5bb543919e5cc677af27";